import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 21.9062C6 16.9855 10.5549 13 16.1786 13H16.8571C18.3585 13 19.5714 14.0613 19.5714 15.375C19.5714 16.6887 18.3585 17.75 16.8571 17.75H16.1786C13.5576 17.75 11.4286 19.6129 11.4286 21.9062V22.5H16.8571C19.8513 22.5 22.2857 24.6301 22.2857 27.25V32C22.2857 34.6199 19.8513 36.75 16.8571 36.75H11.4286C8.43437 36.75 6 34.6199 6 32V29.625V27.25V21.9062ZM27.7143 21.9062C27.7143 16.9855 32.2692 13 37.8929 13H38.5714C40.0728 13 41.2857 14.0613 41.2857 15.375C41.2857 16.6887 40.0728 17.75 38.5714 17.75H37.8929C35.2719 17.75 33.1429 19.6129 33.1429 21.9062V22.5H38.5714C41.5656 22.5 44 24.6301 44 27.25V32C44 34.6199 41.5656 36.75 38.5714 36.75H33.1429C30.1487 36.75 27.7143 34.6199 27.7143 32V29.625V27.25V21.9062Z"
      fill="#9404E7"
    />
  </svg>
);

export default icon;
